export default {
  namespaced: true,
  state: {
    infoSetting: null,
    medicalDept: null,
    userName: null,
    hName: null,
    hAddress: null,
    licenseNum: null,
    shaEnLicenseNum: null,
    shaYoyangNum: null,
    refreshTokenSetting: null,
    region: null,

    isLiveOptionActivity: null,
    isSurveyActivity: null,
    isLiveDiActivity: null,
    isDrugLandingActivity: null,
    drugInfos: [],
    surveys: [],
    drugLandings: [],
    banners: [],
    version: null,
  },
  getters: {
    getInfoSetting: state => state.infoSetting,
    getMedicalDept: state => state.medicalDept,
    getUserName: state => state.userName,
    getHName: state => state.hName,
    getHAddress: state => state.hAddress,
    getLicenseNum: state => state.licenseNum,
    getShaEnLicenseNum: state => state.shaEnLicenseNum,
    getShaYoyangNum: state => state.shaYoyangNum,
    getRefreshTokenSetting: state => state.refreshTokenSetting,
    getRegion: state => state.region,
    getIsLiveOptionActivity: state => state.isLiveOptionActivity,
    getIsSurveyActivity: state => state.isSurveyActivity,
    getIsLiveDiActivity: state => state.isLiveDiActivity,
    getIsDrugLandingActivity: state => state.isDrugLandingActivity,
    getDrugInfos: state => state.drugInfos,
    getSurveys: state => state.surveys,
    getDrugLandings: state => state.drugLandings,
    getBanners: state => state.banners,
    getVersion: state => state.version,
  },
  mutations: {
    setInfoSetting(state, infoSetting) {
      state.infoSetting = infoSetting
    },
    setMedicalDept(state, medicalDept) {
      state.medicalDept = medicalDept
    },
    setUserName(state, userName) {
      state.userName = userName
    },
    setHName(state, hName) {
      state.hName = hName
    },
    setHAddress(state, hAddress) {
      state.hAddress = hAddress
    },
    setLicenseNum(state, licenseNum) {
      state.licenseNum = licenseNum
    },
    setShaEnLicenseNum(state, shaEnLicenseNum) {
      state.shaEnLicenseNum = shaEnLicenseNum
    },
    setShaYoyangNum(state, shaYoyangNum) {
      state.shaYoyangNum = shaYoyangNum
    },
    setRefreshTokenSetting(state, refreshTokenSetting) {
      state.refreshTokenSetting = refreshTokenSetting
    },
    setRegion(state, region) {
      state.region = region
    },
    setIsLiveOptionActivity(state, isLiveOptionActivity) {
      state.isLiveOptionActivity = isLiveOptionActivity
    },
    setIsSurveyActivity(state, isSurveyActivity) {
      state.isSurveyActivity = isSurveyActivity
    },
    setIsLiveDiActivity(state, isLiveDiActivity) {
      state.isLiveDiActivity = isLiveDiActivity
    },
    setIsDrugLandingActivity(state, isDrugLandingActivity) {
      state.isDrugLandingActivity = isDrugLandingActivity
    },
    setDrugInfos(state, drugInfos) {
      state.drugInfos = drugInfos
    },
    setSurveys(state, surveys) {
      state.surveys = surveys
    },
    setDrugLandings(state, drugLandings) {
      state.drugLandings = drugLandings
    },
    setBanners(state, banners) {
      state.banners = banners
    },
    setVersion(state, version) {
      state.version = version
    },
    clear(state) {
      state.infoSetting = null
      state.medicalDept = null
      state.userName = null
      state.hName = null
      state.hAddress = null
      state.licenseNum = null
      state.shaEnLicenseNum = null
      state.shaYoyangNum = null
      state.refreshTokenSetting = null
      state.region = null
      state.isLiveOptionActivity = null
      state.isSurveyActivity = null
      state.isLiveDiActivity = null
      state.isDrugLandingActivity = null
      state.drugInfos = []
      state.surveys = []
      state.drugLandings = []
      state.banners = []
      state.version = null
    },
  },
  actions: {},
}
